import { combineReducers } from "redux";

import * as api from "../lib/workable";

const GET_JOBS = "GET_JOBS";
const GET_JOB = "GET_JOB";

const sanitizeJobsData = (jobs) => {
  return jobs
    .filter((job) => {
      return job.state === "published" &&
        job.title &&
        job.full_title &&
        job.department &&
        job.code &&
        job.location &&
        job.location.country_code &&
        job.location.country &&
        job.location.city;
    });
};


const jobs = (state = [], action = {}) => {
  switch (action.type) {
  case GET_JOBS:
    return action.items;
  default:
    return state;
  }
};

const jobDetail = (state = {}, action = {}) => {
  switch (action.type) {
  case GET_JOB:
    return action.item;
  default:
    return state;
  }
};

export const getJobs = () => async (dispatch) => {
  const items = await api.getJobs();
  const sanitizedJobs = sanitizeJobsData(items);

  dispatch({
    type: GET_JOBS,
    items: sanitizedJobs
  });
};

export const getJobDetail = (shortcode) => async (dispatch) => {
  const item = await api.getJob(shortcode);

  dispatch({
    type: GET_JOB,
    item
  });
};

const reducer = combineReducers({
  jobs,
  jobDetail
});

export default reducer;



// WEBPACK FOOTER //
// ./modules/workable.js